import styles from 'views/StaticContent/SoftSkills/SoftSkills.module.scss';

export function EmptyTableContent() {
  return <div className={styles.emptyTableContent}>No soft skills found.</div>;
}
